import { render } from "./GnosisIcon.vue?vue&type=template&id=9230df48&scoped=true"
import script from "./GnosisIcon.vue?vue&type=script&lang=js"
export * from "./GnosisIcon.vue?vue&type=script&lang=js"

import "./GnosisIcon.vue?vue&type=style&index=0&id=9230df48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9230df48"]])

export default __exports__